import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from 'router/authentication/ProtectedRoute';
import Dashboard from 'Screens/Dashboard/Dashboard';
import Settings from 'Screens/Dashboard/Settings/Settings';
import Subscription from 'Screens/Dashboard/Subscription/Subscription';
import LoginScreen from 'Screens/Login/LoginScreen';
import RegisterScreen from 'Screens/Register/RegisterScreen';
import Events from 'Screens/Dashboard/Events/Events';
import EventsConfiguration from 'Screens/Dashboard/EventsConfiguration/EventsConfiguration';
import Team from 'Screens/Dashboard/Team/Team';
import AllEntities from 'Screens/Dashboard/AllEntities/AllEntities';
import { Loading } from '@carbon/react';
import ParishBookView from 'Screens/Dashboard/ParishBook/ParishBookView/ParishBookView';
import AnnouncementsView from 'Screens/Dashboard/Announcements/AnnouncementsView/AnnouncementsView';
import OffersView from 'Screens/Dashboard/Offers/OffersView/OffersView';

const PasswordRecoveryScreen = lazy(() => import('Screens/PasswordRecovery/PasswordRecoveryScreen'));
const AccountCreationConfirmationScreen = lazy(() => import('Screens/AccountCreationConfirmation/AccountCreationConfirmationScreen'));
const AccountActivationScreen = lazy(() => import('Screens/AccountActivation/AccountActivation'));
const EmailChangeConfirmationScreen = lazy(() => import('Screens/EmailChangeConfirmation/EmailChangeConfirmation'));

const Router = () => (
    <BrowserRouter>
        <Suspense fallback={<Loading />}>
            <Routes>
                <Route element={<ProtectedRoute />}>
                    <Route path="" element={<Dashboard />}>
                        <Route path="events" element={<Events />} />
                        <Route path="events-configuration" element={<EventsConfiguration />} />
                        <Route path="team" element={<Team />} />
                        <Route path="subscription" element={<Subscription />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="entities" element={<AllEntities />} />
                        <Route path="/parish-book" element={<ParishBookView />} />
                        <Route path="/announcements" element={<AnnouncementsView />} />
                        <Route path="/offers" element={<OffersView />} />
                    </Route>
                </Route>
                <Route path="/register" element={<RegisterScreen />} />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/confirmation" element={<AccountCreationConfirmationScreen />} />
                <Route path="/recovery" element={<PasswordRecoveryScreen />} />
                <Route path="/activate-account" element={<AccountActivationScreen />} />
                <Route path="/confirm-email-change" element={<EmailChangeConfirmationScreen />} />
            </Routes>
        </Suspense>
    </BrowserRouter>
);

export default Router;
